import { Link } from "react-router-dom";
import { usePageMeta } from "@/lib/seo";

export default function NotFoundPage() {
  usePageMeta("Page not found", "This page doesn't exist on The ShopAdvisor.", undefined, true);
  return (
    <div className="min-h-[70vh] pt-28 pb-20 px-4 bg-[#f6f5f1]" data-testid="not-found-page"><div className="max-w-2xl mx-auto">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-600">Error 404</p>
      <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight mt-2">This page took a wrong turn.</h1>
      <p className="text-slate-600 mt-4">The link may be old or mistyped. Here's where most people are headed:</p>
      <div className="flex flex-wrap gap-2 mt-6">{[["/", "Home"], ["/products", "Products"], ["/pricing", "Pricing"], ["/solutions", "Solutions"], ["/directory", "Find a shop"], ["/demo", "Book a demo"]].map(([to, l]) =>
        <Link key={to} to={to} className="h-10 px-5 leading-10 rounded-full border border-slate-300 hover:border-slate-900 text-sm font-semibold transition-colors" data-testid={`nf-link-${l.toLowerCase().replace(/ /g, "-")}`}>{l}</Link>)}</div>
    </div></div>
  );
}
